'use client';

import React, { useMemo } from 'react';
import { IconBirthday1 } from '@/features/icons';
import { cn } from '@/utils/cn';
import { useLanguage } from '../../context/language-context-provider';
import SectionHeading from '../section-heading';
const ProgressMobile = () => {
  const {
    t,
    language
  } = useLanguage();
  const isEn = language === 'en';
  const ITEMS = useMemo(() => Array.from({
    length: 13
  }, (_, index) => {
    const itemNumber = index + 1;
    return {
      year: t(`progress.item${itemNumber}.year`),
      name: t(`progress.item${itemNumber}.name`)
    };
  }), [t]);
  return <div className='relative flex flex-col items-center gap-9' data-sentry-component="ProgressMobile" data-sentry-source-file="progress-mobile.tsx">
            <SectionHeading icon={<IconBirthday1 />} title={t('progress.title')} data-sentry-element="SectionHeading" data-sentry-source-file="progress-mobile.tsx" />

            <div className='hide-scrollbar flex w-full overflow-x-scroll pb-2 pt-1'>
                {ITEMS.map((item, index) => <div key={item.name} className='relative px-4 py-5.5'>
                        <div className='flex flex-col items-center justify-center rounded border border-solid border-primary-main p-2'>
                            <span className='text-caption-12 text-text-darkGray'>{item.year}</span>
                            <span className='whitespace-nowrap text-body-14'>{item.name}</span>
                        </div>

                        {index !== ITEMS.length - 1 && <svg className={cn('absolute top-0 h-full', isEn ? 'left-full' : 'right-full')} width='2' viewBox='0 0 2 109' fill='none'>
                                <path d='M1 0V109' className='stroke-primary-main' strokeWidth='1' strokeLinecap='round' strokeDasharray='4 4' />
                            </svg>}

                        <svg className={cn('absolute w-full', {
          'bottom-0 left-0': !isEn && index % 2 === 0,
          'bottom-0 right-0': isEn && index % 2 === 0,
          'left-0 top-0': !isEn && index % 2 !== 0,
          'right-0 top-0': isEn && index % 2 !== 0,
          'w-1/2': index === 0
        })} height='2' viewBox='0 0 109 2' fill='none' preserveAspectRatio='none'>
                            <path d='M0 1H109' className='stroke-primary-main' strokeWidth='1' strokeDasharray='4 4' style={{
            vectorEffect: 'non-scaling-stroke',
            strokeLinecap: 'round'
          }} />
                        </svg>

                        <div className={cn('absolute left-1/2 h-2 w-2 -translate-x-1/2 rounded-full bg-primary-main', {
          'bottom-[1px] translate-y-1/2': index % 2 === 0,
          'top-[1px] -translate-y-1/2': index % 2 !== 0
        })} />
                    </div>)}
            </div>
        </div>;
};
export default ProgressMobile;